/**
 * Sets element's style.display to 'block' or 'none' based on isDisplayed flag.
 * @param {{style: {display: string}}} element DOM element.
 * @param {boolean} isDisplayed
 */
export const setVisibility = (element, isDisplayed) => {
    if (element) {
        element.style.display = isDisplayed ? 'block' : 'none';
    }
};

export const getLiveChatButton = () => {
    return document?.getElementsByClassName('LPMcontainer')[0];
};

export const hideLiveChatButton = () => {
    const liveChatButton = getLiveChatButton();
    setVisibility(liveChatButton, false);
};

export const getCurrencyFromBody = () => document?.querySelector('body')?.dataset?.currency;
